export default {
  asset: "Assets",
  article: "Articles",
  feature: "Additional Features",
};
